// extracted by mini-css-extract-plugin
module.exports = {"switchBlock":"LabeledSwitch_switchBlock__THjC8","text":"LabeledSwitch_text__3HW0b","textRight":"LabeledSwitch_textRight__1quT4","checkbox":"LabeledSwitch_checkbox__9r9wy"};